export default {
    path: '/modules/task',
    name: 'modules-task',
    component: () => import('@/modules/task/pages/index.vue'),
    children: [
        {
            path: 'list',
            component: () => import('@/modules/task/pages/list.vue'),
            meta: {
                pageTitle: '我的任务',
            }
        },
        {
            path: 'view',
            component: () => import('@/modules/task/pages/list.vue'),
            meta: {
                pageTitle: '我的任务',
                parent: '/modules/task/list',
            }
        }
    ],

};